import { render, staticRenderFns } from "./OptionsMenuMobileComponent.vue?vue&type=template&id=4552493b&scoped=true"
import script from "./OptionsMenuMobileComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionsMenuMobileComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OptionsMenuMobileComponent.vue?vue&type=style&index=0&id=4552493b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4552493b",
  null
  
)

export default component.exports